import { FunctionComponent, useEffect, useState } from 'react'
import styles from './Nav.module.scss'
import { AppBar, Toolbar } from '@mui/material'
import GAComponent from '@/modules/googleanalytics/GAComponent'
import { Role } from '@/types/Role'
import Desktop from '@/modules/desktopMobile/desktop'
import Mobile from '@/modules/desktopMobile/mobile'
import DesktopNav from './LoggedInNav/DesktopNav/desktopNav'
import MobileNav from './LoggedInNav/MobileNav/mobileNav'
import { useLazyQuery } from '@apollo/client'
import { GET_NEWS_NOT_VIEWED } from '@/modules/API/parent/parentNewsHandler'
import customEventHandler from '@/modules/utils/customEventHandler'
import { useAuth } from '@/modules/context/AuthContext'
import { ListenerCallback } from '@capacitor/core'
import { Location, useLocation } from 'react-router-dom'

const Nav: FunctionComponent = () => {
    const { user, authToken } = useAuth()

    const [newsCount, setNewsCount] = useState<number>(0)
    const [getNewsNotViewed] = useLazyQuery(GET_NEWS_NOT_VIEWED)

    useEffect(() => {
        if (user && user.role === Role.parent) {
            getNewsNotViewed().then((r) => {
                if (r.data) {
                    setNewsCount(r.data.getNewsNotViewed)
                }
            })
        }
    }, [user, getNewsNotViewed])

    useEffect(() => {
        const handleNewsCountUpdate: ListenerCallback = (updatedNewsCount: number): void => {
            setNewsCount(updatedNewsCount)
        }

        customEventHandler.subscribe(handleNewsCountUpdate)

        return () => {
            customEventHandler.unsubscribe(handleNewsCountUpdate)
        }
    }, [])

    const location: Location = useLocation()

    const [signUp, setSignUp] = useState<boolean>(false)

    useEffect(() => {
        if (new URLSearchParams(location.search).get('account') === 'signupAutolink') {
            setSignUp(true)
        } else {
            setSignUp(false)
        }
    }, [location])

    return signUp ? null : (
        <GAComponent>
            {user && user.role && authToken && (
                <AppBar className={`${user.role !== Role.parent ? styles.AppBarDaycare : styles.AppBarParent}`}>
                    <Toolbar className={styles.ToolBar}>
                        <Desktop>
                            <DesktopNav
                                userRole={user.role}
                                logoBase64Data={user.currentDaycare?.logoBase64Data}
                                newsCount={newsCount}
                                canReadContracts={user.currentDaycareRights.canReadContracts}
                                canReadFamilies={user.currentDaycareRights.canReadFamilies}
                                canReadNews={user.currentDaycareRights.canReadNewsFeed}
                                hasNewsAccess={user.currentDaycareRights.hasNewsAccess}
                                hasSuggestAccess={user.currentDaycareRights.hasSuggestAccess}
                                hasTaskNoteAccess={user.currentDaycareRights.hasTaskNoteAccess}
                                canReadSuggestions={user.currentDaycareRights.canReadSuggestions}
                                canReadTaskNotes={user.currentDaycareRights.canReadTaskNote}
                                daycare={user.currentDaycare}
                                daycaresLength={user.daycares.length}
                                hasMealAccess={user.currentDaycareRights.hasMealAccess}
                                canReadMeal={user.currentDaycareRights.canReadMeal}
                            />
                        </Desktop>
                        <Mobile>
                            <MobileNav
                                newsCount={newsCount}
                                userRole={user.role}
                                canReadContracts={user.currentDaycareRights.canReadContracts}
                                canReadFamilies={user.currentDaycareRights.canReadFamilies}
                                canReadNews={user.currentDaycareRights.canReadNewsFeed}
                                hasNewsAccess={user.currentDaycareRights.hasNewsAccess}
                                daycare={user.currentDaycare}
                                daycaresLength={user.daycares.length}
                            />
                        </Mobile>
                    </Toolbar>
                </AppBar>
            )}
        </GAComponent>
    )
}

export default Nav
